import { Component, OnInit, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const SP_CONTROLS_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ControlsComponent),
  multi: true
};

@Component({
  selector: 'sp-controls',
  standalone: false,
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss'],
  providers: [SP_CONTROLS_VALUE_ACCESSOR]

})
export class ControlsComponent implements OnInit, ControlIntrface, ControlValueAccessor {
  @Input() type: string = null;
  @Input() checked: boolean = false;
  @Input() label: string = null;
  @Input() name: string = null;
  @Input() data: any[] = null;
  @Input() disabled: boolean = false;
  @Output() changeValue = new EventEmitter<any>();
  @Input() selected = null;
  value;
  onChange: any = () => {};
  onTouched: any = () => {};

  get _checked() {
    return this.checked;
  }

  set _checked(val) {
    this.checked = val;
    this.onChange(val);
    this.onTouched();
  }

  constructor() {}

  ngOnInit() {}

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    if (value) {
      this.checked = value;
      this.selected = value.value ? value.value : value;
      return;
    }
    this.checked = false;
    this.selected = false;
  }

  registerOnTouched(fn: any) {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  switchValue() {
    this._checked = !this._checked;
  }

  emitRadioValue(value) {
    this.changeValue.emit(value);
    this.onChange(value.value ? value.value : value);
    this.selected = value.value ? value.value : value;
  }
}

export interface ControlIntrface {
  type?: string;
  checked?: boolean;
  label?: string;
  name?: string;
  data?: any[];
  disabled?: boolean;
}